const selectErrorByAttribute = (state, attribute) => (
  state.contato.errors && state.contato.errors[attribute] && state.contato.errors[attribute][0]
);

export const selectNomeError = (state) => selectErrorByAttribute(state, 'nome');
export const selectEmailError = (state) => selectErrorByAttribute(state, 'email');
export const selectMensagemError = (state) => selectErrorByAttribute(state, 'mensagem');
